// Reusable Refresh button — drops into any list-page action strip (and is
// auto-wired into `<PageHeader onRefresh={…}>`). Preserves all current
// filters / search / sort / page state because it only re-runs the existing
// `load()` / `reload()` function the caller passes in.
//
// Usage:
//   <RefreshButton onRefresh={reload} loading={loading} />
//
// Visual: ghost-border square button with a spinning icon while busy.

import { useState } from "react";
import { RefreshCw } from "lucide-react";

export function RefreshButton({ onRefresh, loading = false, size = "md", testid = "refresh-button", title = "Refresh list" }) {
  const [pulse, setPulse] = useState(false);
  const busy = loading || pulse;

  const handleClick = async () => {
    if (!onRefresh || busy) return;
    setPulse(true);
    try {
      await onRefresh();
    } finally {
      // small delay so the spin animation is visible even on instant reloads
      setTimeout(() => setPulse(false), 350);
    }
  };

  const dim = size === "sm" ? "w-8 h-8" : "w-9 h-9";
  const icon = size === "sm" ? 13 : 15;

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={busy}
      data-testid={testid}
      title={title}
      className={`${dim} inline-flex items-center justify-center border border-slate-300 bg-white text-slate-700 hover:border-[#F97316] hover:text-[#F97316] disabled:opacity-60 disabled:cursor-wait transition-colors`}
    >
      <RefreshCw size={icon} className={busy ? "animate-spin" : ""} />
    </button>
  );
}
